import React from "react";
import { capitalizeVisibility } from "../Utils/constants";

export function formatDate(dateString) {
  const date = new Date(dateString);
  const options = { month: "short", day: "numeric", year: "numeric" };
  let formattedDate = date.toLocaleDateString("en-US", options);

  const day = date.getDate();
  const suffixes = ["th", "st", "nd", "rd"];
  const suffix =
    suffixes[
      day % 10 < 4 && day % 10 > 0 && (day < 11 || day > 13) ? day % 10 : 0
    ];

  formattedDate = formattedDate
    .replace(/,/, "")
    .replace(/(\d+)/, "$1" + suffix);
  return formattedDate;
}

const PricingPlanTile = ({
  planData,
  showDetailedInfo = false,
  customDescription = null,
  customEndpointLabel = "All Endpoints included",
  customQuotaText = null,
}) => {
  if (!planData) {
    return (
      <div className="subscription-plan-tile">
        <div className="subscription-plan-tile-retired">
          <div className="subscription-plan-description-container">
            <h1 className="subscription-plan-title">No Plan Data</h1>
            <h1 className="subscription-plan-pricing">$0.00</h1>
            <div className="subscription-plan-description">
              No plan information available.
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Handle different data structures (planData.plan vs direct planData)
  const plan = planData.plan || planData;
  
  const planName = plan?.planName || planData?.plan_name || planData?.plan_type || 'Untitled Plan';
  const planPrice = plan?.price || 0;
  const planType = plan?.planType || planData?.plan_type;
  const visibility = plan?.visibility || planData?.visibility;
  const installFee = plan?.installFee;

  const defaultDescription = customDescription || 
    `${capitalizeVisibility(visibility)} plan for unlimited Bundle use per dealership location. Flat rate.`;

  const defaultQuotaText = customQuotaText || `Unlimited calls per month \nNo overage fees`;

  return (
    <div className="subscription-plan-tile">
      <div className="subscription-plan-tile-retired">
        <div className="subscription-plan-description-container">
          <h1 className="subscription-plan-title">
            {planName}
          </h1>
          <h1 className="subscription-plan-pricing">
            $
            {planPrice
              ? Number(planPrice).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                })
              : "0.00"}{" "}
            /
            <span className="price-location" style={{ fontSize: "14px" }}>
              Location <div className="plan-frequency">per Month</div>
            </span>
          </h1>
          {installFee && (
            <div className="subscription-plan-install-fee">
              + ${Number(installFee).toLocaleString("en-US", {
                minimumFractionDigits: 0,
              })} Install Fee
            </div>
          )}
          <div className="subscription-plan-description">
            {defaultDescription}
            {planType && planType !== planName && ` ${planType} plan type.`}
          </div>
        </div>

        <div
          className="subscription-plan-endpoint-container"
          style={{
            paddingBottom: showDetailedInfo ? "20px" : "50px",
            height: showDetailedInfo ? "200px" : "175px",
          }}
        >
          <div>
            <div className="subscription-plan-endpoint-container-label">
              {showDetailedInfo ? "Plan Information" : customEndpointLabel}
            </div>

            <pre className="subscription-plan-container-quota-overage">
              {defaultQuotaText}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingPlanTile;